<wms-dialog-header  [title]="locale['LABEL_SAVE_PROJECT_AS_PROJECT_SHELL']" (onClose)="close('DialogExportProjectAsProjectShell')"  ></wms-dialog-header>
<wms-dialog-body>
  <wms-message [scopeDataset]="message"></wms-message>
  <div class="wm-form">
    <div class="form-group app-composite-widget clearfix">
      <label for="projectShellName" class="control-label app-label col-md-4 required">{{locale['LABEL_PROJECT_SHELL_NAME']}}: </label>
      <div class="col-md-8">
        <input id="projectShellName" class="form-control app-textbox" type="text" [(ngModel)]="projectData.displayName"  [maxlength]="32" (keypress)="hideErrMsg();" />
      </div>
    </div>
    <div class="form-group app-composite-widget clearfix" *ngIf="showCommitMsg">
      <label class="control-label app-label col-md-4 required">{{locale.LABEL_VCS_COMMIT}}</label>
      <div class="col-md-8">
        <textarea rows="2" class="form-control app-textarea" name="commitMsg" [(ngModel)]="projectData.commitMsg"  ng-model-options="{updateOn: 'change blur'}"></textarea>
        <textarea rows="5" class="form-control app-textarea readonly" [(ngModel)]="vcsCommitMsg" readonly="readonly"></textarea>
      </div>
    </div>
  </div>
</wms-dialog-body>
<wms-dialog-footer>
  <button title="{{locale.LABEL_CANCEL}}" [disabled]="disableDialogActions" (click)="close('DialogExportProjectAsProjectShell')" class="button-secondary btn app-button" >
    <span class="btn-caption">{{locale.LABEL_CANCEL}}</span>
  </button>
  <button name="wm-save-as-project-shell" title="{{locale.LABEL_OK}}" [disabled]="!(showCommitMsg && !!projectData.commitMsg)"  (click)="saveProjectAsProjectShell()" class="button-primary btn app-button" >
    <span class="btn-caption">{{locale.LABEL_OK}}</span>
  </button>
</wms-dialog-footer>
